import React from 'react';
import './GalleryDoc.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';

const GalleryDoc = () => {
  return (
    <div className="gallery_app">
      <SideMenuBar />

      <main className="content">
        <NewHeader />

        <div className="gallery_container">
          <section className="gallery_page_heading">
            <div>
              <span className="page_kicker">PROJECT ASSETS</span>
              <h1>Gallery</h1>
              <p>Keep project media and documents organized in one workspace.</p>
            </div>

            <div className="gallery_stats">
              <span className="gallery_stat_dot" />
              <span>Document workspace</span>
            </div>
          </section>

          <section className="gallery_workspace">
            <div className="gallery_workspace_header">
              <div className="gallery_tabs">
                <a href="/GalleryMedia" className="gallery_tab">
                  <span className="gallery_tab_icon">▧</span>
                  Media
                </a>
                <a href="/GalleryDoc" className="gallery_tab active">
                  <span className="gallery_tab_icon">▤</span>
                  Documents
                </a>
              </div>

              <div className="gallery_header_hint">
                <span>DOCUMENT LIBRARY</span>
                <strong>Ready for uploads</strong>
              </div>
            </div>

            <div className="gallery_empty_state">
              <div className="gallery_upload_visual">
                <div className="gallery_upload_icon_wrap">
                  <img src="../assets/gallery.png" alt="" className="uploadPhoto_icon_GalleryDoc" />
                </div>
                <span className="upload_glow" />
              </div>

              <span className="page_kicker">DOCUMENTS</span>
              <h2>Build your project document library</h2>
              <p>
                Store briefs, reports, PDFs, proposals and other important project files
                in a clean, searchable workspace.
              </p>

              <a href="/" className="gallery_primary_action">
                <span>＋</span>
                Upload document
              </a>

              <div className="gallery_upload_meta">
                <span>PDF</span>
                <span>DOCX</span>
                <span>XLSX</span>
                <span>PPTX</span>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default GalleryDoc;
